import { JSX } from "react";
import MegaMenuHeader from "./MegaMenuHeader";
import MegaMenuLink from "./MegaMenuLink";
import MenuItemEnum from "@app/layout/menus/menuItemEnum";
import RoleRestricted from "@app/user/RoleRestricted";
import Roles from "@app/user/roles";

//NOTE: Once a page is moved from 1.0 to 2.0, the MegaMenuStandardLink should be replaced with MegaMenuLink to prevent an unnecessary re-rendering of the whole page
const AdminMenu = (): JSX.Element => {
  return (
    <ul className="menu">
      <li>
        <MegaMenuHeader title="Admin" />
        <ul className="menu">
          <RoleRestricted allowedRoles={[Roles.QUEST_ADMIN, Roles.CLIENT_ADMIN]}>
            <MegaMenuLink faIcon="cogs" menuItem={MenuItemEnum.Admin} to={`/admin/dashboard`} linkText="Dashboard" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.ACCESS_REPORTS_WIZARD_ADMIN]}>
            <MegaMenuLink faIcon="cogs" menuItem={MenuItemEnum.AccessReportsAdmin} to={`/access-reports/admin/dashboard/`} linkText="Access Reports" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.PERFORMANCE_MONITOR]}>
            <MegaMenuLink faIcon="rocket" menuItem={MenuItemEnum.Performance} to="/performance/dashboard" linkText="Performance Dashboard" />
          </RoleRestricted>
          <RoleRestricted allowedRoles={[Roles.QUEST_ADMIN, Roles.CLIENT_ADMIN, Roles.QUEST_INTERNAL_REPORTS]}>
            <MegaMenuLink faIcon="copy" menuItem={MenuItemEnum.InternalReports} to="/admin/internal-reports/" linkText="Internal Reports" />
          </RoleRestricted> 
        </ul>
      </li>
    </ul>
  );
};

export default AdminMenu;
